import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import { SingleBadge } from '@ynap/badge'

const bem = new BEMHelper('ConsideredInfo')

const ConsideredInfo = (props) => {
    const {
        className,
        locale,
        title,
        subTitle,
        bodyTextOne,
        bodyTextTwo,
        actionText,
        href,
        hrefSuffix,
        bodyTextThree,
        consideredBadge,
        orderConfirmation = false,
        onLinkClick,
    } = props

    return (
        <div className={bem('consideredWrapper', orderConfirmation === true ? 'confirmation' : null, className)}>
            <SingleBadge
                className={bem('consideredBadge')}
                considered={true}
                badge={{ label: consideredBadge, key: 'CONSIDERED_BADGE' }}
                translation={consideredBadge}
            />
            {title && <h3 className={bem('consideredTitle')}>{title}</h3>}
            {subTitle && <p className={bem('consideredBody', 'subTitle')}>{subTitle}</p>}
            {bodyTextOne && <p className={bem('consideredBody')}>{bodyTextOne}</p>}
            {actionText && href && (
                <p className={bem('consideredBody')}>
                    {bodyTextThree}
                    <span
                        className={bem('consideredActionText')}
                        onClick={() => {
                            onLinkClick(`/${locale.id}${href}`)
                            window.open(`/${locale.id}${href}`)
                        }}
                    >
                        {actionText}
                    </span>
                    {hrefSuffix && <span className={bem('consideredBody')}>{hrefSuffix}</span>}
                </p>
            )}
            {bodyTextTwo && <p className={bem('consideredBody')}>{bodyTextTwo}</p>}
        </div>
    )
}

export default ConsideredInfo
